import { t as intlTelInputWithUtils_default } from "@theme/intlTelInputWithUtils";
//#region frontend/islands/affiliate-signup.js
var AffiliateSignup = class extends HTMLElement {
	connectedCallback() {
		this._phone = this.querySelector("[data-phone]");
		this._iti = intlTelInputWithUtils_default(this._phone, {
			initialCountry: "us",
			separateDialCode: true
		});
		const arrowEl = this.querySelector(".iti__arrow");
		const tpl = this.querySelector("[data-arrow-icon]");
		if (arrowEl && tpl) arrowEl.replaceChildren(tpl.content.cloneNode(true));
		this._handleInput = () => {
			this._phone.setCustomValidity("");
		};
		this._handleCountryChange = () => {
			this._phone.setCustomValidity("");
		};
		this._handleSubmit = this._onSubmit.bind(this);
		this._phone.addEventListener("input", this._handleInput);
		this._phone.addEventListener("countrychange", this._handleCountryChange);
		this.querySelector("form").addEventListener("submit", this._handleSubmit);
	}
	_onSubmit(e) {
		e.preventDefault();
		if (!this._iti.isValidNumber()) {
			this._phone.setCustomValidity("Please enter a valid phone number");
			this._phone.reportValidity();
			return;
		}
		const data = Object.fromEntries(new FormData(e.target));
		data["phone"] = this._iti.getNumber();
		console.log(data);
	}
	disconnectedCallback() {
		this._phone?.removeEventListener("input", this._handleInput);
		this._phone?.removeEventListener("countrychange", this._handleCountryChange);
		this.querySelector("form")?.removeEventListener("submit", this._handleSubmit);
		this._iti?.destroy();
	}
};
customElements.define("affiliate-signup", AffiliateSignup);
//#endregion
